/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    CARD: 'card',
    BANK_ACCOUNT: 'bankAccount',
    SEPA: 'sepa',
    BITCOIN: 'bitcoin',
    LITECOIN: 'litecoin',
};
